<template>
  <div ref="subGlobal" class="global-main global-shadow">

    <div class='global-panel' v-loading.body="loading.main" style="padding: 10px">
      <div class="global-header">
        <div class="global-title">成绩发布</div>
        <div class='global-tbar'>
          <el-upload class="upload-demo"
                     :action="'rest/scoreTask/batchUploadScoreFile?taskId='+currentRecord.id"
                     :on-progress="uploadProgress"
                     :on-error="uploadError" :on-success="uploadSuccess" :on-preview="handlePreview"
                     :on-remove="handleRemove" :file-list="fileList" :show-file-list='false'
                     list-type="picture">
            <el-button type="success" size="small" icon="el-icon-upload2">上传多次成绩excel</el-button>
          </el-upload>
          <el-button size="small" type="success"  @click="downloadMultipleAttachment()">下载多次成绩模板</el-button>
          <el-upload class="upload-demo"
                     :action="'rest/scoreTask/uploadScoreFile?taskId='+currentRecord.id"
                     :on-progress="uploadProgress"
                     :on-error="uploadError" :on-success="uploadSuccess" :on-preview="handlePreview"
                     :on-remove="handleRemove" :file-list="fileList" :show-file-list='false'
                     list-type="picture">
            <el-button type="primary" size="small" icon="el-icon-upload2">上传单次成绩excel</el-button>
          </el-upload>
          <el-button size="small" type="primary"  @click="downloadSingleAttachment()">下载单次成绩模板</el-button>
          <el-button size="small" type="danger"  @click="addTask()">新增</el-button>
          <el-input size="small" v-model="condition.taskName" placeholder="任务名称"></el-input>
          <el-button size="small" type="primary"  @click="findByCondition()">检索</el-button>
        </div>
      </div>
      <hr>
      <div class='global-body'>
        <el-row>
          <el-col :span="17">
            <el-card shadow="hover" style="margin: 10px;">
            <div class="global-paging" v-show="paging.allNum > paging.everySize" >
              <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
            </div>
            <el-table :data="taskList" border stripe style="width: 100%" size="mini" highlight-current-row @current-change="handleTaskChange">
              <el-table-column type="index" width="50"></el-table-column>
              <el-table-column prop="taskName" label="任务名称" sortable width="250"></el-table-column>
              <el-table-column prop="visible" label="是否可见" width="100" sortable>
                <template slot-scope="scope">
                  <el-tag v-show="scope.row.visible" type="success">可见</el-tag>
                  <el-tag v-show="!scope.row.visible" type="danger">不可见</el-tag>
                </template>
              </el-table-column>

              <el-table-column prop="startTime" label="开始时间" width="150" sortable></el-table-column>
              <el-table-column prop="endTime" label="结束时间" width="150" sortable show-overflow-tooltip></el-table-column>
              <el-table-column prop="taskStatus" label="状态" width="100">
                <template slot-scope="scope">
                  <el-tag v-show="scope.row.taskStatus=='未开始'" type="success">{{scope.row.taskStatus}}</el-tag>
                  <el-tag v-show="scope.row.taskStatus=='进行中'" type="danger">{{scope.row.taskStatus}}</el-tag>
                  <el-tag v-show="scope.row.taskStatus=='已结束'" type="info">{{scope.row.taskStatus}}</el-tag>
                  <el-tag v-show="scope.row.taskStatus=='已冻结'" type="info">{{scope.row.taskStatus}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="taskType" label="任务类型" sortable width="100"></el-table-column>
              <el-table-column label="操作" min-width="220" align="center" fixed="right">
                <template slot-scope="scope">
                  <el-button class="global-text-btn-success" size="mini" type="text" @click="showTask(scope.row)" style="margin-left: 10px;">编辑</el-button>
                  <el-button class="global-text-btn-danger" size="mini" type="text" @click="dropTask(scope.row)" style="margin-left: 10px;">删除</el-button>
                  <el-button class="global-text-btn-primary" size="mini" type="text" @click="editSubject(scope.row)" style="margin-left: 10px;">编辑科目</el-button>
                  <el-button class="global-text-btn-danger" size="mini" type="text" @click="toHistory(scope.row)" style="margin-left: 10px;">转历史</el-button>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页  -->
            <div v-show="paging.allNum > paging.everySize" class="global-paging">
              <hr/>
              <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
            </div>
            </el-card>
          </el-col>
          <el-col :span="7">
            <el-card shadow="hover" style="margin: 10px;">
              <div class="global-header">
                <div class="global-title">可见范围</div>
                <div class='global-tbar'>
                  <el-button size="small" type="primary"  @click="selectClazz()">选择班级</el-button>
                </div>
              </div>
              <el-table :data="clazzList" style="width: 100%" row-key="id" max-height="450" border stripe size="mini" >
                <el-table-column label="校区" prop="schoolArea" width="100" ></el-table-column>
                <el-table-column label="班级名称" prop="clazzName" min-width="100" ></el-table-column>
                <el-table-column label="操作" prop="desc" fixed="right" width="50">
                  <template slot-scope="scope">
                    <el-button @click="deleteClazz(scope.row)" type="text" style="color: #F56C6C" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <el-dialog :visible.sync="visible.param" width="50%" v-loading="loading.param" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="serverForm"  :model="currentRecord" label-width="80px":rules="serverRules">
        <el-form-item label="任务名称" prop="taskName">
          <el-input v-model="currentRecord.taskName"></el-input>
        </el-form-item>
        <el-form-item label="展示时间">
          <el-col :span="11">
            <el-date-picker v-model="currentRecord.startTime" type="datetime" placeholder="开始时间" style="width: 100%"/>
          </el-col>
          <el-col :span="2" class="text-center">
            <div style="text-align: center;"><span>-</span></div>
          </el-col>
          <el-col :span="11">
            <el-date-picker v-model="currentRecord.endTime" type="datetime" placeholder="结束时间" style="width: 100%"/>
          </el-col>
        </el-form-item>
        <el-form-item label="类型" prop="taskType">
          <el-select size="small" v-model="currentRecord.taskType" clearable>
            <el-option v-for="item in scoreTaskCombo" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="描述" prop="taskDesc">
          <el-input v-model="currentRecord.taskDesc" type="textarea"></el-input>
        </el-form-item>
        <el-form-item label="冻结" prop="freeze">
          <el-switch v-model="currentRecord.freeze" />
        </el-form-item>
        <el-form-item label="可见" prop="visible">
          <el-switch v-model="currentRecord.visible" />
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input v-model="currentRecord.note" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible.param = false">取 消</el-button>
      <el-button type="primary" @click="saveTask()">保 存</el-button>
    </span>
    </el-dialog>
    <el-dialog title="班级选择" :visible.sync="visible.selectClazz" v-loading="loading.selectClazz" width="40%" :close-on-click-modal="false">
      <el-card shadow="hover" style="margin: 10px;">
        <div>
          <el-form :inline="true" :model="clazzCondition" class="demo-form-inline" size="mini">
            <el-form-item label="校区">
              <el-input v-model="clazzCondition.schoolArea" placeholder="校区"></el-input>
            </el-form-item>
            <el-form-item label="年级">
              <el-input v-model="clazzCondition.grade" placeholder="年级"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="findClazzByCondition">查询</el-button>
            </el-form-item>
          </el-form>
        </div>

        <el-table :data="allClazzList" style="width: 100%" row-key="id" max-height="450" border stripe size="mini" @selection-change="handleSelectionClazz">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="校区" prop="schoolArea"></el-table-column>
          <el-table-column label="年级" prop="grade"></el-table-column>
          <el-table-column label="班级名称"prop="clazzName"></el-table-column>
        </el-table>
      </el-card>
      <div style="clear: both;"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible.selectClazz = false" size="small">取 消</el-button>
        <el-button type="primary" @click="selectedClazz" size="small">选 中</el-button>
       </span>
    </el-dialog>
    <el-dialog title="科目编辑" :visible.sync="visible.subject" v-loading="loading.subject" width="40%" :close-on-click-modal="false">
      <el-card shadow="hover" style="margin: 10px;">
        <div>
          <el-form :inline="true" :model="subjectModel" class="demo-form-inline" size="mini">
            <el-form-item label="科目">
              <el-input v-model="subjectModel.subject" placeholder="科目"></el-input>
            </el-form-item>
            <el-form-item label="排序">
              <el-input v-model="subjectModel.displayOrder" placeholder="排序"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="addSubject">新增</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table :data="subjectList" style="width: 100%" row-key="id" max-height="450" border stripe size="mini">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="科目" prop="subject"></el-table-column>
          <el-table-column label="排序" prop="displayOrder"></el-table-column>
          <el-table-column label="操作" min-width="180" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button class="global-text-btn-danger" size="mini" type="text" @click="dropSubject(scope.row)" style="margin-left: 10px;">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <div style="clear: both;"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible.subject = false" size="small">取 消</el-button>
       </span>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'ScoreTask',
  data() {
    return {
      // 遮罩
      loading: {main: false, param: false, selectClazz: false, subject: false},
      // 可见
      visible: {param: false, selectClazz: false, subject: false},
      paging: {currPage: 1, everySize: 20, allNum: 0},
      // Combo
      scoreTaskCombo: [],

      taskList: [],
      clazzCondition: {schoolArea: '', grade: ''},
      clazzList: [],
      allClazzList: [],
      subjectList: [],
      fileList: [],
      selectionClazz:[],
      // 查询条件
      condition: {taskName: ''},
      // 当前记录
      currentRecord: {},
      // 科目编辑
      subjectModel: {},
      // 校验规则
      serverRules: {
        taskName: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        startTime: [
          { required: true, message: '该项必填', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '该项必填', trigger: 'change' }
        ]
      }
    }
  },

  /*
   * 初始化
   */
  mounted: function () {
    var vm = this;
    vm.$refs.subGlobal.style.minHeight = (window.innerHeight - vm.$baize.frameTitleHeight) + 'px';
    vm.findByCondition();
    vm.findCombo();
  },

  methods: {
    findCombo: function () {
      var vm = this;
      // 请求后台
      vm.$http.get('rest/sys/combo/findCombo', {params: {className:"com.megrezsoft.app.business.common.enumitem.ScoreTaskType", blank:false}}).then(response => {
        // 更新数据
        vm.scoreTaskCombo = response.body;
      }, response => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      });
    },
    /**
     * 按条件查询
     */
    findByCondition: function (currentPage) {
      var vm = this;
      // 区分分页与查询
      if(currentPage){
        vm.paging.currPage = currentPage;
      } else {
        vm.paging.currPage = 1;
      }
      // 开启遮罩
      vm.loading.main = true;
      var params = {}
      params.taskName = vm.condition.taskName
      params.currPage = vm.paging.currPage
      params.everySize = vm.paging.everySize
      // 请求后台
      vm.$http.get('rest/scoreTask/findByCondition', {params: params}).then(response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 更新数据
        vm.taskList = response.body.taskList;
        vm.paging = response.body.pagingBean;
        // 提示
        vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
      }, response => {
        // 关闭遮罩
        vm.loading.main = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    addTask: function () {
      var vm = this;
      vm.currentRecord = {id:null,taskName:null,startTime:null,endTime:null,taskDesc:null,freeze:false,visible:true};
      vm.visible.param = true;
    },
    showTask: function (record) {
      var vm = this;
      vm.currentRecord = JSON.parse(JSON.stringify(record));
      vm.visible.param = true;
    },
    dropTask: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】成绩发布任务[' + record.taskName + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.post('rest/scoreTask/dropTask', null, {params: {id:record.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findByCondition(vm.paging.currPage);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    toHistory: function (record) {
      var vm = this;
      vm.$confirm('确定要将任务[' + record.taskName + ']转入历史吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.post('rest/scoreTask/toHistory', null, {params: {id:record.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.findByCondition(vm.paging.currPage);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    editSubject: function (record) {
      var vm = this;
      vm.currentRecord = JSON.parse(JSON.stringify(record));
      vm.visible.subject = true;
      vm.findSubjectByTaskId();
    },
    findSubjectByTaskId: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.subject = true;
      vm.subjectList = [];
        // 请求后台
      vm.$http.get('rest/scoreTask/findSubjectByTaskId', {params: {taskId:vm.currentRecord.id}}).then(function (response) {
        // 关闭遮罩
        vm.loading.subject = false;
        // 刷新
        vm.subjectList = response.body.subjectList;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.subject = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    saveTask: function () {
      var vm = this;
      // 校验
      vm.$refs['serverForm'].validate((valid) => {
        if (!valid) {
          // 提示信息
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 获取焦点
          vm.$nextTick(() => {
            vm.$refs['serverForm'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
          })
          return false;
        }
        // 开启遮罩
        vm.loading.param = true;
        vm.currentRecord.startTime = vm.$baize.formatDateToString(new Date(vm.currentRecord.startTime), 'yyyy-MM-dd HH:mm:ss');
        vm.currentRecord.endTime = vm.$baize.formatDateToString(new Date(vm.currentRecord.endTime), 'yyyy-MM-dd HH:mm:ss');
        // 请求后台
        vm.$http.post('rest/scoreTask/saveTask', vm.currentRecord).then(function (response) {
          // 关闭遮罩
          vm.loading.param = false;
          // 关闭窗口
          vm.visible.param = false;
          // 刷新
          vm.findByCondition(vm.paging.currPage);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.param = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      });
    },
    /**
     * 选中任务
     */
    handleTaskChange : function (task) {
      var vm = this;
      vm.currentRecord = task;
      vm.clazzList = [];
      vm.studentList = [];
      if(task) {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.get('rest/scoreTask/findTaskClazz',{params: {taskId:vm.currentRecord.id}}).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 刷新
          vm.clazzList = response.body.clazzList;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }
    },
    selectClazz : function () {
      var vm = this;
      if(!vm.currentRecord.id){
        vm.$alert('请先选择任务', '提示',{type:'error'});
        return;
      }
      vm.visible.selectClazz = true;
      vm.findClazzByCondition();
    },
    deleteClazz: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】班级[' + record.clazzName + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.main = true;
        // 请求后台
        vm.$http.post('rest/scoreTask/deleteScope?scopeId='+record.id).then(function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          vm.handleTaskChange(vm.currentRecord);
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    /**
     * 根据条件查询班级
     */
    findClazzByCondition: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.selectClazz = true;
      // 请求后台
      vm.$http.get('rest/scoreTask/findClazzByCondition?schoolArea=' + vm.clazzCondition.schoolArea + "&grade=" + vm.clazzCondition.grade).then(function (response) {
        // 关闭遮罩
        vm.loading.selectClazz = false;
        // 刷新
        vm.allClazzList = JSON.parse(response.bodyText) ;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.selectClazz = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    /**
     * 选中的数据
     */
    handleSelectionClazz:function (val){
      this.selectionClazz = val;
    },
    /**
     * 选中班级
     */
    selectedClazz: function () {
      var vm = this;
      // 开启遮罩
      vm.loading.selectClazz = true;
      if(!vm.currentRecord){
        vm.$alert('请先选择任务', '提示',{type:'error'});
        return;
      }
      // 请求后台
      vm.$http.post('rest/scoreTask/selectedClazz?taskId='+vm.currentRecord.id, vm.selectionClazz).then(function (response) {
        // 关闭遮罩
        vm.loading.selectClazz = false;
        vm.visible.selectClazz = false;
        vm.handleTaskChange(vm.currentRecord);
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '查询成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.selectClazz = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '查询失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    dropSubject: function (record) {
      var vm = this;
      vm.$confirm('确定要【删除】科目[' + record.subject + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
        // 开启遮罩
        vm.loading.subject = true;
        // 请求后台
        vm.$http.post('rest/scoreTask/dropSubject?subjectId='+record.id).then(function (response) {
          // 关闭遮罩
          vm.loading.subject = false;
          vm.findSubjectByTaskId();
          // 提示
          vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
        }, function (response) {
          // 关闭遮罩
          vm.loading.subject = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      }).catch(() => {
        // 提示
        vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
      });
    },
    uploadProgress:function (event, file, fileList){
      var vm =this
      vm.loading.main = true;
    },
    uploadError:function (err, file, fileList){
      var vm =this
      vm.loading.main = false;
      // 弹出错误信息
      this.$alert(JSON.parse(err.message).message, '警告', {
        confirmButtonText: '确定',
        type: 'error'
      });
    },
    uploadSuccess:function (){
      var vm =this
      vm.loading.main = false;
      vm.$notify({position: 'bottom-right', type: 'success', message: '上传成功'});
      vm.findByCondition()
    },
    handlePreview:function (){

    },
    handleRemove:function (){
    },
    addSubject:function (){
      var vm = this;
      // 开启遮罩
      vm.loading.subject = true;
      // 请求后台
      vm.$http.post('rest/scoreTask/addSubject?taskId='+vm.currentRecord.id, vm.subjectModel).then(function (response) {
        // 关闭遮罩
        vm.loading.subject = false;
        vm.findSubjectByTaskId();
        // 提示
        vm.$notify({position: 'bottom-right', type: 'success', message: '新增成功'});
      }, function (response) {
        // 关闭遮罩
        vm.loading.subject = false;
        // 提示
        vm.$notify({position: 'bottom-right', type: 'error', message: '新增失败'});
        // 异常处理
        vm.$baize.handle(vm, response);
      })
    },
    // 下载多次成绩模板
    downloadMultipleAttachment: function (record) {
      var vm = this;
      // 开启遮罩
      vm.loading.main = true;
      let xhr = new XMLHttpRequest();
      xhr.open('POST', '/rest/scoreTask/downloadMultipleAttachment', true);
      xhr.responseType = 'arraybuffer';
      xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
      xhr.onreadystatechange = function (event) {
        if (this.readyState == 4 && this.status == 200) {
          // 关闭遮罩
          vm.loading.main = false;
          let contentDisposition = xhr.getResponseHeader('Content-Disposition');
          let index = contentDisposition.indexOf("attachment; filename=");
          let fileName = "未知文件"
          if (index >= 0) {
            fileName = contentDisposition.substring(index + 21);
          }
          //生成Blob对象，通过创建的a标签点击下载
          var objectUrl = URL.createObjectURL(new Blob([this.response]));
          var link = document.createElement("a");
          link.download = decodeURIComponent(fileName);
          link.href = objectUrl;
          link.click();
        } else if (this.readyState == 4 && this.status != 200) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '下载失败'});
          vm.$baize.handle(vm, {status: this.status, body: this.response});
        }
      };
      xhr.send();
    },
    // 下载单次成绩模板
    downloadSingleAttachment: function (record) {
      var vm = this;
      // 开启遮罩
      vm.loading.main = true;
      let xhr = new XMLHttpRequest();
      xhr.open('POST', '/rest/scoreTask/downloadSingleAttachment', true);
      xhr.responseType = 'arraybuffer';
      xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
      xhr.onreadystatechange = function (event) {
        if (this.readyState == 4 && this.status == 200) {
          // 关闭遮罩
          vm.loading.main = false;
          let contentDisposition = xhr.getResponseHeader('Content-Disposition');
          let index = contentDisposition.indexOf("attachment; filename=");
          let fileName = "未知文件"
          if (index >= 0) {
            fileName = contentDisposition.substring(index + 21);
          }
          //生成Blob对象，通过创建的a标签点击下载
          var objectUrl = URL.createObjectURL(new Blob([this.response]));
          var link = document.createElement("a");
          link.download = decodeURIComponent(fileName);
          link.href = objectUrl;
          link.click();
        } else if (this.readyState == 4 && this.status != 200) {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '下载失败'});
          vm.$baize.handle(vm, {status: this.status, body: this.response});
        }
      };
      xhr.send();
    }
  }
}
</script>

<style>
.global-main {
  padding: 5px 0;
  position: relative;
  overflow: auto;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

</style>



// WEBPACK FOOTER //
// src/app/ScoreTask.vue